import { cn } from '@ui/atoms/utils/utils';
import Button from '@ui/atoms/design-system/Button';
import { Image } from '@ui/atoms';
import { buttonSizes, buttonTypes } from '@ui/atoms/utils/enums';
import PropTypes from 'prop-types';

const BackButton = ({
    handleGoBack,
    className,
    buttonClassName,
    textContent,
    imageSrc,
    imageAlt,
    imageClassName,
}) => (
    <div
        className={cn('relative flex items-center cursor-pointer', className)}
    >
        <Button
            buttonText={textContent}
            buttonType={buttonTypes.TEXT}
            buttonSize={buttonSizes.EXTRA_SMALL}
            className={cn('!text-basicWhite', buttonClassName)}
            prefixComponent={
                <Image
                    src={imageSrc}
                    alt={imageAlt}
                    className={cn('w-5 h-4', imageClassName)}
                />
            }
            onClick={handleGoBack}
        />
    </div>
);

BackButton.propTypes = {
    handleGoBack: PropTypes.func.isRequired,
    className: PropTypes.string,
    buttonClassName: PropTypes.string,
    textContent: PropTypes.string.isRequired,
    imageSrc: PropTypes.string.isRequired,
    imageAlt: PropTypes.string.isRequired,
    imageClassName: PropTypes.string,
};

export default BackButton;
